import React, { createContext, useContext, useMemo, useState } from 'react';

const initialData = {
  churnedPopup: false,
  noSubscriptionPopup: false,
  pendingAccessPopup: false,
  completeRegistrationPopup: false,
};

export const NotificationPopupContext = createContext(initialData);

const NotificationPopupProvider = props => {
  const [churnedPopup, setChurnedPopup] = useState(initialData.churnedPopup);
  const [noSubscriptionPopup, setNoSubscriptionPopup] = useState(initialData.noSubscriptionPopup);
  const [pendingAccessPopup, setPendingAccessPopup] = useState(initialData.pendingAccessPopup);
  const [completeRegistrationPopup, setCompleteRegistrationPopup] = useState(initialData.pendingAccessPopup);

  const dataValue = useMemo(
    () => ({
      churnedPopup,
      setChurnedPopup,
      noSubscriptionPopup,
      setNoSubscriptionPopup,
      pendingAccessPopup,
      setPendingAccessPopup,
      completeRegistrationPopup,
      setCompleteRegistrationPopup,
    }),
    [churnedPopup, noSubscriptionPopup, pendingAccessPopup, completeRegistrationPopup],
  );

  return <NotificationPopupContext.Provider value={dataValue} {...props} />;
};

export const useNotificationPopup = () => useContext(NotificationPopupContext);

export default NotificationPopupProvider;
